import { render, staticRenderFns } from "./TheTablePage.vue?vue&type=template&id=5e5fc76c"
import script from "./TheTablePage.vue?vue&type=script&lang=js"
export * from "./TheTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports